import { apiUrl } from '../../../../../constants/global';
import axios from 'axios';
import { getLoggedUser } from '../../../../../state/user';

const user = getLoggedUser();
const endpoint = apiUrl + 'v2';

async function getWinningAuctions(filters) {
  const query = new URLSearchParams(filters).toString();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.get(`${endpoint}/auctions/winning?${query}`, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function getWinningClients() {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.get(`${endpoint}/winning-organizations`, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function getUserDetails() {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.get(`${endpoint}/profile`, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function getPaymentHistory() {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.get(`${endpoint}/auction-payment`, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function mzadcomPayment(payload, isFormData = false) {
  let config = {
    headers: {
      Authorization: 'Bearer ' + user.token,
    },
  };

  if (isFormData) {
    config.headers['Content-Type'] = 'multipart/form-data';
  } else {
    config.headers['Content-Type'] = 'application/json';
  }

  try {
    const { data: response } = await axios.post(`${endpoint}/auction-payment`, payload, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

export { getWinningAuctions, getWinningClients, getUserDetails, mzadcomPayment, getPaymentHistory };
